export default __webpack_public_path__ + "static/media/icon-twitter.dde79e7e.svg";